module.exports = __webpack_public_path__ + "img/SketchPng58ac3510fe49a0f5adb3ea5ad70dcf8df3e541b933e91522bad0ac10ebb17374.37733101.png";